import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'

function FormBlogs__Details(props) {
    const { formik } = props

    return (
        <React.Fragment>
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Title"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Title"} // placeholder for the input
                formikFieldName={"blogTitle"} // important: formik value name for the input
                inputType={"text"}
            />

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Author Name"} // label name
                isRequired={false} // is this field is required or not to show the red star sign
                placeholder={"Author Name"} // placeholder for the input
                formikFieldName={"blogAuthor"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Tags"} // label name
                isRequired={false} // is this field is required or not to show the red star sign
                placeholder={"Comma Separated"} // placeholder for the input
                formikFieldName={"blogTags"} // important: formik value name for the input
            />

        </React.Fragment>
    )
}


export default memo(FormBlogs__Details)